<template>
  <div class="dialog-content">
    <div class="dialog-content-item item-space">
      <div class="item-title os-font-14-400">手机IMEI查询：</div>
      <div class="item-content os-font-14-400">拨号键盘输入 *#09# 可查询IMEI</div>
    </div>
    <div class="dialog-content-item item-space">
      <div class="item-title os-font-14-400">平板SN查询：</div>
      <div class="item-content os-font-14-400">
        设置 - 系统管理 - 关于平板电脑 - 状态信息-序列号
      </div>
    </div>
    <div class="dialog-content-item">
      <div class="item-title os-font-14-400">手表SN查询：</div>
      <div class="item-content os-font-14-400">设置 - 关于手表 - 序列号</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'imeiTip'
}
</script>

<style lang="scss" scoped>
.dialog-content {
  .dialog-content-item {
    line-height: 18px;

    .item-title {
      color: #999;
    }

    .item-content {
      color: #333;
    }

    &.item-space {
      margin-bottom: 18px;
    }
  }
}
</style>
